import { createIcon } from "@chakra-ui/react";

const PlayArrowOutlineIcon = createIcon({
  displayName: "PlayArrowOutlineIcon",
  viewBox: "0 0 24 24",
  path: <path d="M8 19V5l11 7zm2-3.65L15.25 12L10 8.65z" fill="currentColor" />,
});

export default PlayArrowOutlineIcon;
